import { BikeConfig } from '../config';

export type LandingVerdict = 'clean' | 'hard' | 'crash';

export interface Landing {
  verdict: LandingVerdict;
  noseError: number;   // rad, bike nose relative to the landing slope; + = nose high (rear first)
  impactSpeed: number; // m/s into the ground along its normal
  airTime: number;     // s
}

/**
 * Grades the first touchdown after a flight: parallel to the slope (or a little rear first) at a moderate speed into
 * the ground is clean; past `landClean` of nose error or `landHardSpeed` it is hard. The grade never throws the
 * rider: 'crash' is only written afterwards, when the suspension or the rider's legs run out (physics/limits.ts).
 */
export function judgeLanding(noseError: number, impactSpeed: number, airTime: number, cfg: BikeConfig): Landing {
  const hard = impactSpeed > cfg.landHardSpeed || Math.abs(noseError) > cfg.landClean;
  return { verdict: hard ? 'hard' : 'clean', noseError, impactSpeed, airTime };
}
